import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Box } from 'rebass/styled-components';
import { ChevronDown } from 'lucide-react';

const TruncatedTextContainer =
  styled.div <
  { isTruncated: PropTypes.bool } >
  `
  position: relative;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: ${({ fontSize }) => fontSize || '14px'};
  ${({ isTruncated }) =>
    isTruncated &&
    css`
      &:after {
        content: '...';
        display: inline-block;
        right: 0;
        bottom: -2px;
      }
    `}
`;

const SeeMoreButton = styled.button`
  appearance: none;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 4px;
  position: absolute;
  right: 0;
  bottom: -3px;
  padding: 4px 8px;
  // box-shadow: 0px -2px 16px 2px white;
  background-color: white !important;
  font-size: 14px;
  &:hover {
    color: ${({ theme }) => theme.colors.purple[500]};
  }
`;

const TruncatedText = ({ text = '', maxLength = 250, fontSize = '14px' }) => {
  const [isTruncated, setIsTruncated] = useState(true);

  const isMoreThanMaxLength = text?.length > maxLength;

  const showMore = () => {
    setIsTruncated(false);
  };

  return (
    <>
      <div style={{ position: 'relative' }}>
        <TruncatedTextContainer
          fontSize={fontSize}
          isTruncated={isTruncated && isMoreThanMaxLength}
          // className={`truncated-text ${isTruncated && isMoreThanMaxLength ? 'truncate' : ''}`}
        >
          {isTruncated ? text?.slice(0, maxLength) : text}
        </TruncatedTextContainer>

        {isTruncated && isMoreThanMaxLength && text?.length > maxLength && (
          <SeeMoreButton type="button" onClick={showMore}>
            See more
            <Box as={ChevronDown} width="16px" height="16px" aria-hidden="true" />
          </SeeMoreButton>
        )}
      </div>
    </>
  );
};

TruncatedText.propTypes = {
  text: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  fontSize: PropTypes.string,
};

TruncatedText.defaultProps = {
  maxLength: 200,
  fontSize: '14px',
};

export default TruncatedText;
